import { Component, Vue, Watch } from 'vue-property-decorator';
import { Action, Getter, Mutation } from 'vuex-class';


@Component({
  beforeRouteEnter(to: any, from: any, next: any) {
    next((vm) => {
      if(vm.getIsToken && !vm.getSubscription) {
        next('/mi-menu/comenzar');
      } else {
        next();
      }
    });
  }

})
export default class SubscriptionIngredients extends Vue {


  @Action action_getPlates;
  @Action action_getTags;
  @Action action_changePlate;

  @Getter getPlatesOptions;
  @Getter getTags;
  @Getter getSubscription;

  @Mutation MENU_OPTIONS;
  @Mutation TAGS;
  @Mutation SET_NEW_PLATE;

 
  // Modal Test
  openModal = false;
  openEditModal = false;
  openFilterDropdown = false;
  openOrderDropdown = false;

  // For Pagination
  pageSize = 8;
  currentPage = 1;

  plates = {}
  tags = {}

  ingredients = [
    { 
      id: 1,
      title: 'Pierna Pernil',
      description: 'Pollo, ajo, cebolla, champiñon, leche, sal, arroz, papa, yuca.',
      weight: '160 gr',
      calories: '100 Kcal.',
      image: 'https://storage-bucket-app.s3.us-east-2.amazonaws.com/App+Usuarios-13.png'
    },
    { 
      id: 2,
      title: 'Pollo Teriyaki',
      description: 'Pollo, Salsa de soya, Vinagre, Azúcar Ajo, Jengibre, Almidón, Agua, Pimienta.',
      weight: '160 gr',
      calories: '100 Kcal.',
      image: 'https://storage-bucket-app.s3.us-east-2.amazonaws.com/pollo+teriyaki+1.png'
    },
    { 
      id: 3,
      title: 'Salmón a las finas hierbas',
      description: 'Salmón, Finas Hierbas, Aceite Vegetal, Sal, Ajo',
      weight: '160 gr',
      calories: '100 Kcal.',
      image: 'https://storage-bucket-app.s3.us-east-2.amazonaws.com/salmon+a+las+finas+hierbas.png'
    },
    { 
      id: 4,
      title: 'Pollo Limeño',
      description: 'Pollo, Cebolla, Pimentón, Pasta de ajo, Crema de leche, Cilantro, Comino, Azúcar, Margarina, Harina de trigo, Sal.',
      weight: '160 gr',
      calories: '100 Kcal.',
      image: 'https://storage-bucket-app.s3.us-east-2.amazonaws.com/Pollo+Lime%C3%B1o+1.png'
    },
    { 
      id: 5,
      title: 'Pierna Pernil',
      description: 'Pollo, ajo, cebolla, champiñon, leche, sal, arroz, papa, yuca.',
      weight: '160 gr',
      calories: '100 Kcal.',
      image: 'https://storage-bucket-app.s3.us-east-2.amazonaws.com/App+Usuarios-13.png'
    },
    { 
      id: 6,
      title: 'Pollo Teriyaki',
      description: 'Pollo, Salsa de soya, Vinagre, Azúcar Ajo, Jengibre, Almidón, Agua, Pimienta.',
      weight: '160 gr',
      calories: '100 Kcal.',
      image: 'https://storage-bucket-app.s3.us-east-2.amazonaws.com/pollo+teriyaki+1.png'
    },
    { 
      id: 7,
      title: 'Salmón a las finas hierbas',
      description: 'Salmón, Finas Hierbas, Aceite Vegetal, Sal, Ajo',
      weight: '160 gr',
      calories: '100 Kcal.',
      image: 'https://storage-bucket-app.s3.us-east-2.amazonaws.com/salmon+a+las+finas+hierbas.png'
    },
    { 
      id: 8,
      title: 'Pollo Limeño',
      description: 'Pollo, Cebolla, Pimentón, Pasta de ajo, Crema de leche, Cilantro, Comino, Azúcar, Margarina, Harina de trigo, Sal.',
      weight: '160 gr',
      calories: '100 Kcal.',
      image: 'https://storage-bucket-app.s3.us-east-2.amazonaws.com/Pollo+Lime%C3%B1o+1.png'
    },
    { 
      id: 9,
      title: 'Pollo Limeño',
      description: 'Pollo, Cebolla, Pimentón, Pasta de ajo, Crema de leche, Cilantro, Comino, Azúcar, Margarina, Harina de trigo, Sal.',
      weight: '160 gr',
      calories: '100 Kcal.',
      image: 'https://storage-bucket-app.s3.us-east-2.amazonaws.com/Pollo+Lime%C3%B1o+1.png'
    },
    { 
      id: 10,
      title: 'Pierna Pernil',
      description: 'Pollo, ajo, cebolla, champiñon, leche, sal, arroz, papa, yuca.',
      weight: '160 gr',
      calories: '100 Kcal.',
      image: 'https://storage-bucket-app.s3.us-east-2.amazonaws.com/App+Usuarios-13.png'
    },
    { 
      id: 11,
      title: 'Pollo Teriyaki',
      description: 'Pollo, Salsa de soya, Vinagre, Azúcar Ajo, Jengibre, Almidón, Agua, Pimienta.',
      weight: '160 gr',
      calories: '100 Kcal.',
      image: 'https://storage-bucket-app.s3.us-east-2.amazonaws.com/pollo+teriyaki+1.png'
    },
    { 
      id: 12,
      title: 'Salmón a las finas hierbas',
      description: 'Salmón, Finas Hierbas, Aceite Vegetal, Sal, Ajo',
      weight: '160 gr',
      calories: '100 Kcal.',
      image: 'https://storage-bucket-app.s3.us-east-2.amazonaws.com/salmon+a+las+finas+hierbas.png'
    }
  ];


  openCollapsible(id: any) {
  
    let content = document.getElementById('collapsible-content-' + id)  as HTMLElement;
    let icon = document.getElementsByClassName('collapsible-icon-' + id)[0]  as HTMLElement;

    if (content.style.maxHeight) {
        
        content.style.maxHeight = null;
        content.style.marginTop = null;
        content.style.marginBottom = null;
        

        icon.style.transform = 'rotate(0deg)';
        content.style.padding = '0';

    } else {
        content.style.padding = '0.2rem';
        content.style.maxHeight = content.scrollHeight + "px";
        content.style.marginTop = 0.6 + 'rem'
        content.style.marginBottom = 0.6 + 'rem'
        

        icon.style.transform = 'rotate(180deg)';

    }


  }

  openFilters() {
    this.openFilterDropdown = !this.openFilterDropdown;
    this.openOrderDropdown = false;
  }

  openOrdering() {
    this.openOrderDropdown = !this.openOrderDropdown;
    this.openFilterDropdown = false;
  }

  nextPage() {
      if((this.currentPage*this.pageSize) < this.ingredients.length) this.currentPage++;
  }

  prevPage() {
      if(this.currentPage > 1) this.currentPage--;
  }

  async _plates() {
    let agregatte = []
    let avoid = []
    let items
    let items2
    for(items of this.getSubscription.tags_aggregate) {
      agregatte.push(items.id)
      
    }
    for(items2 of this.getSubscription.tags_avoid) {
      avoid.push(items2.id)
    }
    this.plates = await this.action_getPlates({ commerceId :'3' , menuId : this.$route.query.Menu , include: agregatte, noInclude:avoid});
    return this.plates
  }

  async _tags() {
    this.tags = await this.action_getTags();
    return this.tags
  }
  __addPlate(id: any) {

    let meals = [];
    let ingredients = [];

    this.$store.state.selectedMeal.items.forEach((meal) => {
      meals.push({
        id: meal.sub_menu_id,
        _destroy: true
      })
    });

    this.$store.state.newPlate.product_menu_item_id.forEach((product) => {
      ingredients.push({
        menu_items_product_id: product,
        menu_option_id: this.$store.state.newPlate.menu_option_id, 
        menu_id : this.$store.state.newPlate.menu_id,
        count_id: Number(this.$route.query.Day)
      })
    });

    let payload = {
        "subscription": {
            "subscription_menus_attributes": [
              ...meals,
              ...ingredients
            ]
        }
    }

    this.action_changePlate({commerceId: 3 , subscriptionId: this.getSubscription.id , payload})
    window.history.back();
  }
  

  mounted() {
    this._plates()
    this._tags()
  }

  get paginatedIngredients() {

    return this.ingredients.slice((this.currentPage-1)*this.pageSize, this.currentPage*this.pageSize);
    /*return this.ingredients.filter((row, index) => {
        let start = (this.currentPage-1)*this.pageSize;
        let end = this.currentPage*this.pageSize;
        if(index >= start && index < end) console.log('true');
        if(index >= start && index < end) return true;
    });*/

    
  }

  hasOverprice(item: any) {
    let overprice = false;
    item.product_menu_items.forEach((product) => { product.over_price ? overprice = true : null });
    return overprice;
  }

  calculateOverprice(item: any) {
    let overprice = false;
    item.product_menu_items.forEach((product) => { overprice += product.over_price })
    return overprice;
  }

}
